export default __webpack_public_path__ + "static/media/banner.eff6957a.jpg";